module.exports = __webpack_public_path__ + "img/completed-check-mark-finsure.36789625.svg";